var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.rooms.length > 0
        ? _c(
            "v-list",
            { attrs: { "three-line": "" } },
            [
              _vm._l(_vm.rooms, function(room) {
                return [
                  _c(
                    "v-list-item",
                    {
                      key: room.id,
                      staticClass: "elevation-3 ma-5",
                      attrs: { to: "/reserve/room/" + room.id }
                    },
                    [
                      _c(
                        "v-list-item-avatar",
                        { attrs: { size: "80", color: "blue-grey lighten-3" } },
                        [
                          !room.image
                            ? _c(
                                "span",
                                { staticClass: "white--text headline" },
                                [_vm._v(_vm._s(_vm._f("initials")(room.name)))]
                              )
                            : _vm._e(),
                          room.image
                            ? _c("v-img", {
                                attrs: {
                                  src:
                                    "https://" +
                                    _vm.keyword +
                                    ".libnet.info/images/roombooking/" +
                                    _vm.keyword +
                                    "/" +
                                    room.image
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "green--text" },
                            [_vm._v("Available")]
                          ),
                          _c("v-list-item-title", {
                            domProps: { innerHTML: _vm._s(room.name) }
                          }),
                          _c("v-list-item-subtitle", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.getLocationForId(room.location_id).name
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-spacer"),
                      room.roomCapacity > 0
                        ? _c(
                            "div",
                            [
                              _c("v-icon", [_vm._v("people_outline")]),
                              _c("span", { staticClass: "pl-1" }, [
                                _vm._v(_vm._s(room.roomCapacity))
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              })
            ],
            2
          )
        : _c("span", [_vm._v("Sorry no rooms matching your criteria")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }